import { useAuthContext } from "../../../context/AuthContext";
import EnhancementNewStockBook from "./EnhancementNewStockBook";

const NewStockBook = () => {
  const { business } = useAuthContext();
  return (<EnhancementNewStockBook business={business} />)
}

export default NewStockBook;
